import React, { forwardRef, RefObject, useContext } from 'react'
import styled, { css } from 'styled-components'

import SliderOverlay from '@Components/Product/Display/SliderOverlay'
import HorizontalSlider from '@Components/Product/Slider/Components/Sliders/Horizontal'
import VerticalSlider from '@Components/Product/Slider/Components/Sliders/Vertical'
import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'
import SliderController from '@Components/Product/Slider/SliderController'
import { up } from '@Globals/Style/breakpoints'

const ProductSlidersRoot = styled.section<{ fullscreen: boolean }>(({ fullscreen }) => css`
  position: relative;
  display: grid;
  background: white;
  top: unset;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  gap: 0;
  grid-gap: 0;

  ${up('mobileStyleThreshold')} {
    position: sticky;
    top: 8px;
    grid-template-columns: 78px 1fr;
    gap: 10px;
    grid-gap: 10px;
  }

  z-index: 10;
  ${fullscreen && css`
    z-index: 1000;
  `}
`)

const ProductSliders = forwardRef((props, scrollToRef: RefObject<HTMLDivElement>) => {
  const { isFullscreen } = useContext(SliderContext)
  return (
    <ProductSlidersRoot fullscreen={isFullscreen}>
      <VerticalSlider />
      <SliderController>
        <HorizontalSlider />
        <SliderOverlay scrollToRef={scrollToRef} />
      </SliderController>
    </ProductSlidersRoot>
  )
})

export default ProductSliders
